module.exports = __webpack_public_path__ + "img/homePei3.3aaf17d8.png";